import React from 'react';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import ShipmentStatusHeader from '../../../../components/shipment-status-header';
import { ReturnShipmentPropType } from '../../../../prop-types/return-shipment';
import { ReturnDetailsPrintDocumentButton } from '../../../../containers/print-document-button-containers/return-details';
import { OtherActionsButtonContainer } from '../../../../components/modals/return-details-modal/return-details-modal-content/other-actions-button-container';
import { emptyObject } from 'ui-components/default-props/empty';

import { ReturnDetailsBody } from './return-details-body';

import style from './return-details-modal-content.module.less';

export const ReturnDetailsModalContent = (props) => {
  // NOTE: returnId is a fulfillmentId from the return data.
  const { isLoading = false, returnShipment = emptyObject, closeModal } = props;
  const rmaNumber = get(returnShipment, 'rmaNumber');
  if (isLoading) {
    return (
      <div className={classnames(style['return-details-modal-content'], style.loading)}>
        <LoadingIndicator />
      </div>
    );
  }

  return (
    <div className={style['return-details-modal-content']}>
      <div className={style['content-header']}>
        <ShipmentStatusHeader isReturn onClose={() => closeModal()} returnShipment={returnShipment} rmaNumber={rmaNumber}>
          <div className={style['return-details-header-buttons']}>
            <ReturnDetailsPrintDocumentButton fulfillmentId={get(returnShipment, 'fulfillmentId')} />
            <OtherActionsButtonContainer returnShipment={returnShipment} />
          </div>
        </ShipmentStatusHeader>
      </div>
      <ReturnDetailsBody {...props} />
    </div>
  );
};

ReturnDetailsModalContent.propTypes = {
  closeModal: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  rmaNumber: PropTypes.string,
  returnShipment: ReturnShipmentPropType,
};
